var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Zm.5 3.571c.786 0 1.5.643 1.5 1.5 0 .858-.643 1.5-1.5 1.5-.786 0-1.5-.642-1.5-1.5 0-.857.643-1.5 1.5-1.5Zm-.786 13.5c-1.285 0-2.214-1.214-1.857-2.428l1.286-4.286c.143-.5-.214-.928-.714-.928h-.643a2.617 2.617 0 0 1 2.5-1.786c1.285 0 2.214 1.214 1.857 2.428l-1.286 4.286c-.143.5.214.929.714.929h.643a2.617 2.617 0 0 1-2.5 1.786Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.e92e636e4325669349579e70d254553c.svg";